import { apiClient } from '../client'
import { AUTH_TOKEN_KEY } from '../../lib/env'
import type { ApiSuccessResponse } from '../../types/api'
import type { AuthSession } from '../../types/auth'

type AuthPayload = Omit<AuthSession, 'token'>

/** Auth API — components call this service only, never apiClient. */
export const authService = {
  async login(email: string, password: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<null>>('/auth/login', {
      email,
      password,
    })
    return data
  },

  async verifyOtp(email: string, otp: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<AuthPayload & { token: string }>>(
      '/auth/verify-otp',
      { email, otp },
    )

    localStorage.setItem(AUTH_TOKEN_KEY, data.data.token)

    return data
  },

  async requestAdminPasswordReset(email: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<null>>('/reset/password', {
      email,
    })
    return data
  },

  async me() {
    const { data } = await apiClient.get<ApiSuccessResponse<AuthPayload>>('/auth/me')
    return data
  },

  async logout() {
    try {
      await apiClient.post('/auth/logout')
    } finally {
      localStorage.removeItem(AUTH_TOKEN_KEY)
    }
  },
}
